/*
 * Style option (Classic / Diamond ...) on the seat product page. snippets/seatfit-style-state.liquid sets
 * html[data-sf-style] in <head> and defines window.SeatFitStyle; this file keeps the attribute in step with the buy
 * box: a click on a Style pill, and Shrine's variantChange (a pick made by the vehicle steps, a ?style= link, a
 * colour repair). The snippet's CSS then shows only the [data-sf-style-only] elements and chapter slides of the style
 * on show. This file is the only writer of the attribute: SeatFitStyle.watch(fn) hands every move to scripts that
 * must agree with that CSS (the chapter gallery), so they never read the buy box on their own.
 *
 * Sliders: Shrine's <splide-component> takes every slide of its list when it mounts, so a card hidden by CSS would
 * still get a page, a dot and an empty position. Loaded `defer` from <head>, this file runs once the page is parsed
 * and before Shrine's deferred secondary.js defines the slider: each slider holding style-only cards is copied as
 * parsed, then keeps only the current style's cards. A style switch puts in a fresh copy pruned for the new style,
 * which Shrine mounts like any new slider (the old instance goes with its detached element).
 *
 * Colour: a Style switch ticks, before Shrine's own handler, the colour the new style sells that is nearest the
 * current one (assets/seatfit-style-color-match.js), so Shrine lands on a real variant instead of repairing by position.
 * Posters: videos of style-only elements carry data-sf-poster (a poster downloads even while hidden); the style on
 * show gets its posters here, the others never download theirs.
 */
(function () {
  'use strict';
  var S = window.SeatFitStyle;
  if (!S || S.follow) return;
  var root = document.documentElement;
  var STYLE_CARDS = '.splide__list > [data-sf-style-only]';
  var SYNCED = 'sf-style-synced'; // the buy box shows the style on show: the <head> CSS stops hiding it
  var COLOR = 'Color'; // the colour option, by the name the vehicle steps and the chapter gallery read too
  var sliders = [];
  // Scripts that must show the same style as the CSS (the chapter gallery) take it from here, never from the buy box.
  var watchers = [];

  function current() { return root.getAttribute('data-sf-style') || ''; }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  // Same treatment as the videos the parser inserted (snippets/seatfit-video-diet.liquid): nothing downloads early.
  function diet(root) {
    var fn = window.SeatFitVideoDiet;
    if (typeof fn === 'function') each(root.querySelectorAll('video'), fn);
  }

  function posters(scope, style) {
    if (!style) return;
    var sel = '[data-sf-style-only="' + style + '"] video[data-sf-poster], .sfc__slide[data-style="' + style + '"] video[data-sf-poster]';
    each(scope.querySelectorAll(sel), function (v) {
      v.setAttribute('poster', v.getAttribute('data-sf-poster'));
      v.removeAttribute('data-sf-poster');
    });
  }

  function prune(host, style) {
    each(host.querySelectorAll(STYLE_CARDS), function (li) {
      if (li.getAttribute('data-sf-style-only') !== style) li.parentNode.removeChild(li);
    });
  }

  function adopt() {
    each(document.querySelectorAll('splide-component'), function (host) {
      if (host.hasAttribute('data-sf-style-slider') || !host.querySelector(STYLE_CARDS)) return;
      host.setAttribute('data-sf-style-slider', '');
      if (host.querySelector('.splide.is-initialized')) {
        // Ran after Shrine mounted it: the CSS still hides the other style's cards, their slots stay.
        console.warn('[SeatFit style] slider mounted before seatfit-style-state.js; cards not pruned');
        return;
      }
      diet(host);
      var rec = { host: host, html: host.outerHTML, style: current() };
      prune(host, rec.style);
      sliders.push(rec);
    });
  }

  function rebuild(rec, style) {
    if (!rec.host.isConnected) return; // the theme editor re-rendered the section
    var box = document.createElement('div');
    box.innerHTML = rec.html;
    var fresh = box.firstElementChild;
    if (!fresh) return;
    prune(fresh, style);
    posters(fresh, style);
    diet(fresh);
    rec.host.replaceWith(fresh);
    rec.host = fresh;
    rec.style = style;
    // Muted loops in the new cards start when on screen, as the page's first ones do (seatfit-home-media.js).
    var media = window.SeatFitHomeMedia;
    if (media && typeof media.watch === 'function') media.watch(fresh);
  }

  function follow(handle) {
    if (!handle || handle === current() || !S.styles.some(function (s) { return s.h === handle; })) return;
    root.setAttribute('data-sf-style', handle);
    sliders.forEach(function (rec) {
      if (rec.style === handle) return;
      try { rebuild(rec, handle); } catch (e) { console.warn('[SeatFit style] slider rebuild failed', e); }
    });
    posters(document, handle);
    watchers.forEach(function (fn) {
      try { fn(handle); } catch (e) { console.warn('[SeatFit style] watcher failed', e); }
    });
  }

  try { adopt(); } catch (e) { console.warn('[SeatFit style] slider prune failed', e); }
  // After adopt(): the slider copies keep data-sf-poster, so each rebuild sets only its own style's posters.
  posters(document, current());
  S.follow = follow;
  S.watch = function (fn) { if (typeof fn === 'function') watchers.push(fn); };

  // Capture phase on the document runs before Shrine's 'change' handler on <variant-selects>, which reads every
  // checked radio: when the checked colour is not sold in the checked style (a Style pill, a Style radio the steps
  // queued), tick the nearest sold one without an event so Shrine resolves an existing variant.
  function checkedIn(vs, name) {
    var r = Array.prototype.filter.call(vs.querySelectorAll('input[type="radio"]'), function (i) {
      return i.name === name && i.checked;
    })[0];
    return r ? r.value : '';
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    var vs = t && t.type === 'radio' && t.closest ? t.closest('variant-selects') : null;
    if (!vs) return;
    // A shopper's own pick is already the buy box on show (no wait for Shrine to re-render).
    if (e.isTrusted && t.name === S.option) root.classList.add(SYNCED);
    var C = window.SeatFitStyleColor;
    if (!C) return;
    try {
      var now = checkedIn(vs, COLOR);
      var want = C.colorFor(vs, checkedIn(vs, S.option), now, COLOR);
      if (!want || want === now) return;
      each(vs.querySelectorAll('input[type="radio"]'), function (r) { if (r.name === COLOR && r.value === want) r.checked = true; });
    } catch (err) { console.warn('[SeatFit style] colour for the new style failed', err); }
  }, true);

  // A pill click: the look swaps at once, before Shrine's section fetch lands.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.type === 'radio' && t.name === S.option) follow(S.handleOf(t.value));
  });

  // Shrine's pub/sub comes from its own deferred main.js, which runs AFTER this file: while deferred scripts run the
  // document is already 'interactive', so waiting for 'loading' to end would miss it. DOMContentLoaded fires once
  // every deferred script has run; 'load' is the late fallback.
  var subscribed = false;
  function subscribeVariant() {
    if (subscribed || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribed = true;
    subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
      var v = ev && ev.data && ev.data.variant;
      if (v && v.options) follow(S.handleOf(v.options[S.position - 1]));
      root.classList.add(SYNCED); // Shrine re-rendered the buy box for this variant
    });
  }
  subscribeVariant();
  if (!subscribed && document.readyState !== 'complete') {
    document.addEventListener('DOMContentLoaded', subscribeVariant);
    window.addEventListener('load', subscribeVariant);
  }
})();
